export default "/_next/static/images/bd6a457242399e82f4e4e52fffd32504.jpg";